export enum DocumentTypeEnum {
  GENERIC = 'GENERIC',
  DRIVER_LICENSE = 'DRIVER_LICENSE',
  DOT_MEDICAL = 'DOT_MEDICAL',
  DRIVER_CHECKLIST = 'DRIVER_CHECKLIST',
  RETURN_TO_WORK = 'RETURN_TO_WORK',
  MEDICAL_DISCONTINUANCE = 'MEDICAL_DISCONTINUANCE',
  PHOTO_ID = 'PHOTO_ID',
}

export enum GroupDocumentTypeEnum {
  ONBOARDING = 'ONBOARDING',
}
